module.exports = __webpack_public_path__ + "static/media/logo_reports_branco.457dfa1f.png";